export default __webpack_public_path__ + "static/media/manual22.07864d2f.png";